import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/addOns/catalog/license.addOn.upsert.mutation.gql"
import type {
  AddOnUpsertMutation,
  AddOnUpsertMutationVariables,
} from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.upsert.mutation"

type Options = MutationHookOptions<
  AddOnUpsertMutation,
  AddOnUpsertMutationVariables
>

export function useAddOnUpsertMutation(options?: Options) {
  return useMutation<AddOnUpsertMutation, AddOnUpsertMutationVariables>(
    mutation,
    options,
  )
}
